import "core-js/modules/es.array.includes";
import "core-js/modules/es.function.name";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "E:\\\u5EAD\u5BA1\u9879\u76EE\\trial_2.1.0_code\\hikcourt-web\\hikcourt-web\\trial-web\\node_modules\\core-js\\modules\\es.array.iterator.js";
import "E:\\\u5EAD\u5BA1\u9879\u76EE\\trial_2.1.0_code\\hikcourt-web\\hikcourt-web\\trial-web\\node_modules\\core-js\\modules\\es.promise.js";
import "E:\\\u5EAD\u5BA1\u9879\u76EE\\trial_2.1.0_code\\hikcourt-web\\hikcourt-web\\trial-web\\node_modules\\core-js\\modules\\es.object.assign.js";
import "E:\\\u5EAD\u5BA1\u9879\u76EE\\trial_2.1.0_code\\hikcourt-web\\hikcourt-web\\trial-web\\node_modules\\core-js\\modules\\es.promise.finally.js";
import moment from 'moment';
import Vue from 'vue';
import HUI from 'hui';
import 'hui/lib/hui.css';
import Empty from '@hui-pro/empty';
import ImgView from '@hui-pro/img-view';
import '@hui-pro/empty/theme/index.scss';
import selectTreeOption from '@hui-pro/select-tree-option';
import '@hui-pro/select-tree-option/theme/index.scss'; // @ts-ignore

import Eits from 'eits';
import 'eits/lib/eits.css';
import VueLocalStorage from 'vue-localstorage';
import App from './App.vue';
import router from './router';
import '@/config/loadIcon';
import '@hui-pro/img-view/theme/index.scss';
import store from './store/index';
import '@/assets/styles/reset.css';
import '@/assets/styles/hui-variables.scss';
import '@/assets/styles/style.css';
Vue.config.performance = process.env.NODE_ENV === 'development';
Vue.config.productionTip = false;
Vue.use(ImgView);
Vue.use(HUI);
Vue.use(Empty);
Vue.use(Eits);
Vue.use(selectTreeOption);
Vue.prototype.$moment = moment;
Vue.use(VueLocalStorage);
router.beforeEach(function (to, from, next) {
  // console.log('路由守卫', to, from)
  // if (['CaseManage'].includes(to.name) && ['CaseInfo', 'CaseUpdate'].includes(from.name)) {
  //   to.meta.keepAlive = true
  // } else {
  //   to.meta.keepAlive = false
  // }
  var toDepth = to.path.split('/').length;
  var fromDepth = from.path.split('/').length;
  var cache = toDepth < fromDepth && ['CaseManage'].includes(to.name) && ['CaseInfo', 'CaseUpdate'].includes(from.name); // console.log('缓存', cache)

  if (cache) {
    // console.log('back...')
    from.meta.keepAlive = false;
    to.meta.keepAlive = true;
  }

  next();
});
new Vue({
  router: router,
  store: store,
  render: function render(h) {
    return h(App);
  }
}).$mount('#app');